import React from "react";

export default function Loader() {
  return (
    <div className="loader">
      <svg viewBox="0 0 100 100">
        <defs>
          <filter id="shadow">
            <feDropShadow
              floodColor="#000"
              stdDeviation="1.5"
              dy="0"
              dx="0"
            />
          </filter>
        </defs>
        <circle
          r="45"
          cy="50"
          cx="50"
          style={{
            fill: "transparent",
            stroke: "#5b90ab70",
            strokeWidth: 7,
            strokeLinecap: "round",
            filter: "url(#shadow)",
          }}
          id="spinner"
        ></circle>
      </svg>
    </div>
  );
}
